/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Contact_InvalidInputs */

const en_error_contact_invalid = /** @type {(inputs: Error_Contact_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The contact can't be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The contact can't be saved as it is:" |
*
* @param {Error_Contact_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_contact_invalid = /** @type {((inputs?: Error_Contact_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Contact_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_contact_invalid(inputs)
});